/**
 * Which track fits the moment: read from the world, never changing it. In order: jail, a boss
 * near, a fight (outside the safe town), meditating, standing in a training spot, night, the wilds
 * of a zone, and the zone's own track (data/zones.ts `music`).
 */
import { ZONES, type World } from '@nine/shared';

/** Within this many tiles of a living boss, its music plays. */
const BOSS_RANGE = 14;
/** This close to the zone's plaza counts as in town. */
const TOWN_RANGE = 14;

export function musicFor(w: World): string {
  const p = w.player;
  if (p.jailT > 0) return 'jail';
  if ([w.boss, w.worldBoss].some((b) => b && !b.dead && Math.hypot(b.x - p.x, b.y - p.y) < BOSS_RANGE))
    return 'boss';
  const town = w.inSafeZone(p) || Math.hypot(p.x - w.map.plaza.x, p.y - w.map.plaza.y) < TOWN_RANGE;
  if (p.combatT > 0 && !town) return 'battle';
  if (p.meditating) return 'meditation';
  if (w.trainingSpot) return 'training';
  const zone = ZONES[w.map.zone];
  if (w.dayPart === 'night') return zone.nightMusic ?? 'night';
  if (!town && zone.wildMusic) return zone.wildMusic;
  return zone.music;
}
